import React from 'react';
import { motion } from 'framer-motion';

const DashboardMetrics = ({ data }) => {
  const { learners, campaigns, complianceRecords, phishingSimulations, assignments = [] } = data;

  const totalLearners = learners.length;
  const activeCampaigns = campaigns.filter(c => c.status === 'Active').length;
  
  // Overdue training dynamically calculated from assignments table
  const overdueTraining = assignments.filter(a => a.status === 'Overdue').length;
  
  const totalSent = phishingSimulations.reduce((acc, sim) => acc + (sim.sent ?? 0), 0);
  const totalClicked = phishingSimulations.reduce((acc, sim) => acc + (sim.clicked ?? 0), 0);
  const totalReported = phishingSimulations.reduce((acc, sim) => acc + (sim.reported ?? 0), 0);

  const avgClickRate = totalSent > 0 ? ((totalClicked / totalSent) * 100).toFixed(1) : 0;
  const avgReportRate = totalSent > 0 ? ((totalReported / totalSent) * 100).toFixed(1) : 0;
  
  const compliant = complianceRecords.filter(r => r.status === 'Compliant').length;
  const compliancePct = complianceRecords.length > 0 ? Math.round((compliant / complianceRecords.length) * 100) : 0;

  const cards = [
    { label: 'Total Learners',   value: totalLearners,        valueColor: 'text-slate-900', sub: 'Total assigned' },
    { label: 'Active Campaigns', value: activeCampaigns,      valueColor: 'text-blue-600',  sub: `of ${campaigns.length} total` },
    { label: 'Overdue Training', value: overdueTraining,      valueColor: 'text-amber-600', sub: 'Modules overdue' },
    { label: 'Avg Click Rate',   value: `${avgClickRate}%`,   valueColor: 'text-red-600',   sub: 'Across simulations' },
    { label: 'Report Rate',      value: `${avgReportRate}%`,  valueColor: 'text-emerald-600', sub: 'Across simulations' },
    { label: 'Compliance',       value: `${compliancePct}%`,  valueColor: compliancePct >= 80 ? 'text-emerald-600' : 'text-amber-600', sub: `${compliant} of ${complianceRecords.length} records` },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
      {cards.map((c, i) => (
        <motion.div key={c.label} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}
          className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm flex flex-col justify-between min-h-[100px]">
          <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{c.label}</span>
          <div>
            <span className={`text-3xl font-bold ${c.valueColor} mt-2 block`}>{c.value}</span>
            {c.sub && <span className="text-[10px] text-slate-400 mt-1 block">{c.sub}</span>}
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default DashboardMetrics;